import React from 'react'
import { SelectInput } from '../ui/Form'
import { cx } from '../ui/format'

/** Kept for older screens: options [{ id, title }] with a "Select {name}" placeholder. */
const Select = ({ name, options = [], value, onChange, width, disabled }) => (
  <SelectInput
    className={cx('inline-block', width || 'w-52')}
    value={value}
    onChange={onChange}
    disabled={disabled}
    aria-label={name}
    placeholder={`Select ${name}`}
    options={options.map((item) => ({ value: item.id, label: item.title }))}
  />
)

export default Select
